import { useEffect, useRef } from "react";
import { Text } from "@chakra-ui/react";
import { Clock } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMyCart } from "../../contexts/MyCartContext";
import FloatingToast from "./FloatingToast";

const ORANGE = "#EA580C";
// Must match CART_TOAST_DURATION in useDraftBookingNotifications
const BAR_DURATION = 10;

const ADDON_TOAST_OFFSET = "5.5rem";

const BOOKING_FLOW_PATHS = [
  "/book",
  "/packages",
];

function isBookingFlow(path: string) {
  return BOOKING_FLOW_PATHS.some((p) => path.startsWith(p));
}

export default function PendingCartToast() {
  const { pendingCartToast, toast: addOnToast, visibleDrafts, pendingPackageCount } = useMyCart();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const prevPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    const prev = prevPathnameRef.current;
    prevPathnameRef.current = pathname;

    if (
      prev !== null &&
      isBookingFlow(prev) &&
      !isBookingFlow(pathname) &&
      pathname !== "/my-cart" &&
      visibleDrafts.length + pendingPackageCount > 0
    ) {
      pendingCartToast.show();
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (pathname === "/my-cart" && pendingCartToast.visible) {
      pendingCartToast.dismiss();
    }
  }, [pathname, pendingCartToast]);

  const topOffset =
    addOnToast.visible && pathname !== "/my-cart" ? ADDON_TOAST_OFFSET : "1rem";

  return (
    <FloatingToast
      visible={pendingCartToast.visible && pathname !== "/my-cart"}
      toastKey="pending-cart-toast"
      accentColor={ORANGE}
      icon={<Clock size={15} color="white" />}
      title="You have pending payments"
      description={<Text>Tap to complete checkout before they expire</Text>}
      top={topOffset}
      zIndex={9997}
      onClick={() => {
        pendingCartToast.dismiss();
        navigate("/my-cart");
      }}
      onDismiss={pendingCartToast.dismiss}
      progressDurationSeconds={BAR_DURATION}
      progressKey={pendingCartToast.visible ? "bar-active" : "bar-idle"}
    />
  );
}
